var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 9.16671V10.8334H18.3337V9.16671H15.0003ZM13.3337 14.675C14.1337 15.2667 15.1753 16.05 16.0003 16.6667C16.3337 16.225 16.667 15.775 17.0003 15.3334C16.1753 14.7167 15.1337 13.9334 14.3337 13.3334C14.0003 13.7834 13.667 14.2334 13.3337 14.675ZM17.0003 4.66671C16.667 4.22504 16.3337 3.77504 16.0003 3.33337C15.1753 3.95004 14.1337 4.73337 13.3337 5.33337C13.667 5.77504 14.0003 6.22504 14.3337 6.66671C15.1337 6.06671 16.1753 5.29171 17.0003 4.66671ZM3.33366 7.50004C2.41699 7.50004 1.66699 8.25004 1.66699 9.16671V10.8334C1.66699 11.75 2.41699 12.5 3.33366 12.5H4.16699V15.8334H5.83366V12.5H6.66699L10.8337 15V5.00004L6.66699 7.50004H3.33366ZM12.917 10C12.917 8.89171 12.4337 7.89171 11.667 7.20837V12.7834C12.4337 12.1084 12.917 11.1084 12.917 10Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotice);
export default __webpack_public_path__ + "static/media/icon_notice.2545921abf5850913a93b1a5795f305b.svg";
export { ForwardRef as ReactComponent };